import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import {  withStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
    popper: {
        fontWeight: 400,
        fontSize: '12px',
    },
    user:{
        marginLeft: '40px',
    },
    info: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "#fff",
        backgroundColor: "#C4C4C4",
        borderRadius: "50%",
        width: "15px",
        height: "15px",
        marginLeft:'10px'
    },
}));

const InfoToolTip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#eee',
      color: "#001128",
      maxWidth: 220,
      fontSize:'14px',
      textAlign:'center'

    },
  }))(Tooltip);

export default function Info({ value, item }) {
    const classes = useStyles();

    return (
        <InfoToolTip
            className={classes.info}
            title={<div>{value}</div>}
            arrow
            placement="top"
        >
            <div className={classes.popper}>i</div>
        </InfoToolTip>
    );
}
